import { gql } from '@apollo/client'

export const CREATE_ROUND_ROUTE_PLAN = gql`
    mutation addRoundRoutePrice($round_price: BoatRoundPriceInput!) {
        addRoundRoutePrice(round_price: $round_price) {
            code
            success
            message
        }
    }
`

export const UPDATE_ROUND_ROUTE_PLAN = gql`
    mutation updateRoundRoutePrice($price_id: NonEmptyString!, $round_price: BoatRoundPriceInput!) {
        updateRoundRoutePrice(price_id: $price_id, round_price: $round_price) {
            code
            success
            message
        }
    }
`

export const HANDLE_ROUND_ROUTE_PLAN = gql`
    mutation EnableDisbleRoundTripPrice($priceId: NonEmptyString!, $statusCode: RoundTripPriceStatus!) {
        enableDisbleRoundTripPrice(price_id: $priceId, status_code: $statusCode) {
            code
            success
            message
        }
    }
`
